import { Service } from "src/service/service";
import { UiStore } from "./UiStore";
import { action, makeObservable, observable } from "mobx";
import { Placement } from "src/adl-gen/kachemedia/specsheet/db";
import { DbKey } from "src/adl-gen/common/db";
import {
  CAMPAIGN_PERMISSIONS,
  idFlavor,
  N_CampaignVersionInfo,
  N_InfoSchemaTableViewColumn,
  N_PublicationView,
} from "@specsheet-common/shared-types";

export interface AddMissingPlacementDrawerContext {
  kind:
    | "addPlacement"
    | "addMissingPlacement"
    | "importCampaign"
    | "addBySiteId";
  bookingGroupId?: idFlavor<"BookingGroup">;
  bookingGroupName?: string;
}
interface EditMissingPlacementDrawerContext {
  kind: "editMissingPlacement";
  placementId: DbKey<Placement>;
}
interface CampaignHistoryDrawerContext {
  kind: "campaignHistory";
  campaignId: idFlavor<"Campaign">;
  customColumns: N_InfoSchemaTableViewColumn[];
  publications: N_PublicationView[];
  campaignPermissions: CAMPAIGN_PERMISSIONS[];
  versionsHistory: N_CampaignVersionInfo[];
  unpublishedChangesCounts: number;
  onRevertClick(): void;
  onShareCampaignClick(): void;
}

export type DrawerContext =
  | EditMissingPlacementDrawerContext
  | AddMissingPlacementDrawerContext
  | CampaignHistoryDrawerContext;

export class PlacementDrawerStore {
  drawerContext: DrawerContext | null = null;

  constructor(
    private readonly uiStore: UiStore,
    private readonly service: Service
  ) {
    this.uiStore = uiStore;
    this.service = service;

    makeObservable(this, {
      drawerContext: observable,
      setDrawerContext: action,
    });
  }

  setDrawerContext = (drawerContext: DrawerContext | null) => {
    if (drawerContext) {
      this.drawerContext = drawerContext;
    } else {
      this.drawerContext = null;
    }
  };
}
